// Victor 2026-05-26: el CRM usa el diseño oscuro M1.B (fondos negros + cristal).
// En modo claro el texto queda ILEGIBLE (texto oscuro sobre burbujas oscuras),
// porque el tema seguía el del SO ('auto'). Forzamos SIEMPRE modo noche, sin
// importar el sistema operativo ni el ajuste guardado.
export const setColorTheme = () => {
  document.body.classList.add('dark');
  document.documentElement.style.setProperty('color-scheme', 'dark');
};
